import ApiHelper from '@/common/ApiHelper';
const api = new ApiHelper();
import { Toast } from 'antd-mobile';
import { detailQuery } from '@/interface/req';
let basic_url = process.env.BASIC_URL;

export function getMovieDeatil(id) {
  // /movie/detail
  return api.Post(basic_url + '/movie/detail', { cityId: '', movieId: id }).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res.Message);
  });
}
